export default "__VITE_ASSET__4dc7d186__"